import React from "react"
import logoPng from "../../assets/sequence-logo.png"
import footerPng from "../../assets/horizon-logo.png"
import { MailingListInput } from "../MailingList"
import { URIS } from "../../constants"

export const Footer = ({ className }) => (
  <footer>
    <div className={`container ${className}`}>
      <div
        className="flex flex-col items-center flex-1 justify-between pt-10 w-full lg:flex-row lg:items-start"
        style={{ minHeight: 400 }}
      >
        <div className="flex flex-col flex-1 items-center text-center px-4 max-w-xs md:max-w-sm w-full lg:items-start lg:text-left">
          <img
            className="mb-5"
            style={{ height: 40 }}
            alt="logo"
            src={logoPng}
          />

          <MailingListInput grayscale small />

          <p className="mt- note"></p>
        </div>

        <div className="flex flex-col lg:flex-row flex-1 text-center max-w-3xl order-1 my-4 lg:my-0 lg:ml-8">
          <div className="flex flex-col flex-1 items-end">
            <FooterLink href={URIS.contact}>Contact</FooterLink>
            <FooterLink href={URIS.docs}>Docs</FooterLink>
            <FooterLink href={URIS.horizon}>Team</FooterLink>
          </div>

          <div className="flex flex-col flex-1 items-end order-4 lg:order-2">
            <FooterLink href={URIS.github}>Github</FooterLink>
            <FooterLink href={URIS.discord}>Discord</FooterLink>
            <FooterLink href={URIS.twitter}>Twitter</FooterLink>
          </div>

          <div className="flex flex-col flex-1 items-end order-3">
            <FooterLink href={URIS.privacy}>Privacy</FooterLink>
            <FooterLink href={URIS.terms}>Terms</FooterLink>
          </div>
        </div>
      </div>

      <div className="flex flex-1 flex-col-reverse lg:flex-row items-center justify-between pb-7 mt-4 lg:mt-0 lg:pr-8">
        <div>
          <p className="my-2 note">Sequence®</p>
          <p className="my-2 note">
            Copyright &copy; {new Date().getFullYear()} Horizon Blockchain Games
            Inc.
          </p>
        </div>

        <a
          className="flex items-center"
          href={URIS.horizon}
          target="_blank"
          rel="noreferrer"
        >
          <p className="my-2 mr-4 hidden note lg:block">Built by</p>
          <img alt="logo" src={footerPng} style={{ height: 26 }} />
        </a>
      </div>
    </div>
  </footer>
)

const FooterLink = ({ children, href = "", sup = "", disabled = false }) => (
  <a
    href={href}
    target={href.match(/^http/) && !disabled ? "_blank" : undefined}
    rel="noreferrer"
    disabled={disabled}
    className="px-2 py-2 lg:text-left text-gray"
  >
    {children}
    <sup>{sup}</sup>
  </a>
)
